import { Sutl } from '../../../../sutl';
import { Subject } from '../framework/rx/Subject';
const monitorRoles = ['First', 'Second', 'Third', 'Fourth'];
const pipPositions = [
    'UpperLeft',
    'UpperCenter',
    'UpperRight',
    'CenterLeft',
    'CenterRight',
    'LowerLeft',
    'LowerRight',
];
// Note: The emulator only supports the JSON output mode.
// Note: Feedback registrations only support basic XPath expressions like /foo/bar, and only a small
// subset of paths are supported.
export class CiscoTelepresence {
    constructor(socket, log) {
        this.socket = socket;
        this.callId = 0;
        this.echo = true;
        this.keymap = {}; // keymap[lowercase] = uppercase;
        this.registrations = {};
        this.resultIdRegExp = /(.+)\s+\|\s+resultId="(.+)"\s*$/;
        this.sendTerminator = '\r\n';
        this.cameraPresets = [
            {
                CameraId: {
                    Value: '1',
                },
                DefaultPosition: {
                    Value: 'False',
                },
                Name: {
                    Value: 'screen',
                },
                PresetId: {
                    Value: '1',
                },
                id: '1',
            },
        ];
        this.state = {
            Status: {
                Audio: {
                    Microphones: {
                        Mute: {
                            Value: 'Off',
                        },
                    },
                    Volume: {
                        Value: '50',
                    },
                },
                Call: [],
                Cameras: {
                    Camera: ['1', '2', '3', '4'].map(id => ({
                        Capabilities: {
                            Options: {
                                Value: 'ptzf',
                            },
                        },
                        DetectedConnector: {
                            Value: '1',
                        },
                        id,
                    })),
                    SpeakerTrack: {
                        Availability: {
                            Value: 'Unavailable',
                        },
                        Status: {
                            Value: 'Active',
                        },
                    },
                },
                Capabilities: {
                    Conference: {
                        MaxAudioCalls: {
                            Value: '2',
                        },
                        MaxVideoCalls: {
                            Value: '1',
                        },
                    },
                },
                Conference: {
                    Presentation: {},
                },
                GPIO: {
                    Pin: [
                        {
                            id: '1',
                            State: {
                                Value: 'High',
                            },
                        },
                        {
                            id: '2',
                            State: {
                                Value: 'High',
                            },
                        },
                        {
                            id: '3',
                            State: {
                                Value: 'High',
                            },
                        },
                        {
                            id: '4',
                            State: {
                                Value: 'High',
                            },
                        },
                    ],
                },
                Standby: {
                    State: {
                        Value: 'Standby',
                    },
                },
                SystemUnit: {
                    Hardware: {
                        Module: {
                            SerialNumber: {
                                Value: 'AVEOSYSTEMS',
                            },
                        },
                    },
                    Software: {
                        DisplayName: {
                            Value: 'RoomOS 10.19.1.7 8292f3590ec',
                        },
                    },
                },
                Video: {
                    Selfview: {
                        FullscreenMode: {
                            Value: 'Off',
                        },
                        Mode: {
                            Value: 'Off',
                        },
                        OnMonitorRole: {
                            Value: 'First',
                        },
                        PIPPosition: {
                            Value: 'CenterRight',
                        },
                    },
                },
            },
        };
        this.stateSubject = new Subject();
        this.asyncHandlers = [
            {
                match: (cmd) => this.matchPath(cmd, ['echo'], 1, true),
                callback: cmd => {
                    if (cmd.path[1] === 'off') {
                        this.echo = false;
                    }
                    else if (cmd.path[1] === 'on') {
                        this.echo = true;
                    }
                    else {
                        this.socket.send(`Insufficient arguments`);
                        this.socket.send(`usage: echo [on/off]`);
                        this.socket.send(``);
                        this.socket.send(` Command to control input echo:`);
                        this.socket.send(`  echo on    Turns input echo on`);
                        this.socket.send(`  echo off   Turns input echo off`);
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'audio', 'microphones'], 1),
                callback: cmd => {
                    var _a;
                    const value = (_a = cmd.path[3]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                    if (value === 'mute') {
                        this.sendCommandResponse(cmd.resultId, 'MicrophonesMuteResult', 'OK');
                        const newState = Sutl.deepCopy(this.state);
                        newState.Status.Audio.Microphones.Mute.Value = 'On';
                        this.updateState(newState);
                    }
                    else if (value === 'unmute') {
                        this.sendCommandResponse(cmd.resultId, 'MicrophonesUnmuteResult', 'OK');
                        const newState = Sutl.deepCopy(this.state);
                        newState.Status.Audio.Microphones.Mute.Value = 'Off';
                        this.updateState(newState);
                    }
                    else {
                        this.sendXPathError(cmd.path, cmd.resultId, 'Unknown command');
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'audio', 'volume', 'set']),
                callback: cmd => {
                    if (!this.argsIncludesRequired(cmd.args, ['level']) ||
                        !this.argsAreValid(cmd.args, ['level'])) {
                        this.sendCommandResponse(cmd.resultId, 'VolumeSetResult', 'ParameterError');
                        return;
                    }
                    const value = parseInt(cmd.args.level, 10);
                    if (Number.isNaN(value) || value < 0 || value > 100) {
                        this.sendCommandResponse(cmd.resultId, 'VolumeSetResult', 'ParameterError');
                        return;
                    }
                    this.sendCommandResponse(cmd.resultId, 'VolumeSetResult', 'OK');
                    const newState = Sutl.deepCopy(this.state);
                    newState.Status.Audio.Volume.Value = value.toString();
                    this.updateState(newState);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'call', 'accept']),
                callback: cmd => {
                    if (!this.argsIncludesRequired(cmd.args, ['callid']) ||
                        !this.argsAreValid(cmd.args, ['callid'])) {
                        this.sendCommandResponse(cmd.resultId, 'CallAcceptResult', 'ParameterError');
                        return;
                    }
                    const call = this.findCall(cmd.args.callid);
                    if (call === undefined || !('Status' in call)) {
                        const extra = {
                            Cause: { Value: '12' },
                            Description: { Value: 'Participant not found' },
                        };
                        this.sendCommandResponse(cmd.resultId, 'CallAcceptResult', 'Error', extra);
                        return;
                    }
                    if (call.Status.Value !== 'Ringing') {
                        const extra = {
                            Cause: { Value: '16' },
                            Description: { Value: 'Operation unavailable' },
                        };
                        this.sendCommandResponse(cmd.resultId, 'CallAcceptResult', 'Error', extra);
                        return;
                    }
                    this.sendCommandResponse(cmd.resultId, 'CallAcceptResult', 'OK');
                    const newState = Sutl.deepCopy(this.state);
                    const newCall = this.findCall(cmd.args.callid, newState);
                    if (newCall !== undefined && 'Status' in newCall) {
                        newCall.Status.Value = 'Connected';
                    }
                    this.updateState(newState);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'call', 'disconnect']),
                callback: cmd => {
                    if (!this.argsIncludesRequired(cmd.args, ['callid']) ||
                        !this.argsAreValid(cmd.args, ['callid'])) {
                        this.sendCommandResponse(cmd.resultId, 'CallDisconnectResult', 'ParameterError');
                        return;
                    }
                    const call = this.findCall(cmd.args.callid);
                    if (call === undefined || !('Status' in call)) {
                        const extra = {
                            Cause: { Value: '12' },
                            Description: { Value: 'Participant not found' },
                        };
                        this.sendCommandResponse(cmd.resultId, 'CallAcceptResult', 'Error', extra);
                        return;
                    }
                    const callId = call.id;
                    this.sendCommandResponse(cmd.resultId, 'CallDisconnectResult', 'OK');
                    const newState = Sutl.deepCopy(this.state);
                    const newCalls = newState.Status.Call.filter(call => call.id !== callId);
                    newState.Status.Call = [...newCalls, { id: callId, ghost: 'True' }];
                    this.updateState(newState);
                    newState.Status.Call = newCalls; // don't update afterwards
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'call', 'dtmfsend']),
                callback: cmd => {
                    if (!this.argsIncludesRequired(cmd.args, ['callid', 'dtmfstring']) ||
                        !this.argsAreValid(cmd.args, ['callid', 'dtmfstring'])) {
                        this.sendCommandResponse(cmd.resultId, 'CallDTMFSendResult', 'ParameterError');
                        return;
                    }
                    const call = this.findCall(cmd.args.callid);
                    if (call === undefined || !('Status' in call)) {
                        const extra = {
                            Cause: { Value: '12' },
                            Description: { Value: 'Participant not found' },
                        };
                        this.sendCommandResponse(cmd.resultId, 'CallDTMFSendResult', 'Error', extra);
                        return;
                    }
                    if (call.Status.Value !== 'Connected') {
                        const extra = {
                            Cause: { Value: '16' },
                            Description: { Value: 'Operation unavailable' },
                        };
                        this.sendCommandResponse(cmd.resultId, 'CallDTMFSendResult', 'Error', extra);
                        return;
                    }
                    this.sendCommandResponse(cmd.resultId, 'CallDTMFSendResult', 'OK');
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'camera', 'preset', 'activate']),
                callback: cmd => {
                    let status = 'OK';
                    if (!this.argsIncludesRequired(cmd.args, ['presetid']) ||
                        !this.argsAreValid(cmd.args, ['presetid'])) {
                        status = 'ParameterError';
                    }
                    else {
                        this.wake();
                        const preset = this.cameraPresets.find(p => p.PresetId === cmd.args.presetid);
                        if (preset === undefined) {
                            this.sendCommandErrorWithReason(cmd.resultId, 'PresetActivateResult', 'Preset does not exist');
                            return;
                        }
                    }
                    this.sendCommandResponse(cmd.resultId, 'PresetActivateResult', status);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'camera', 'preset', 'list']),
                callback: cmd => {
                    this.sendCommandResponse(cmd.resultId, 'PresetListResult', 'OK', {
                        Preset: this.cameraPresets,
                    });
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'camera', 'ramp']),
                callback: cmd => {
                    let status = 'OK';
                    if (!this.argsIncludesRequired(cmd.args, ['cameraid']) ||
                        !this.argsAreValid(cmd.args, [
                            'cameraid',
                            'pan',
                            'panspeed',
                            'tilt',
                            'tiltspeed',
                            'zoom',
                            'zoomspeed',
                            'focus',
                        ])) {
                        status = 'ParameterError';
                    }
                    else {
                        this.wake();
                    }
                    this.sendCommandResponse(cmd.resultId, 'CameraRampResult', status);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'cameras', 'speakertrack'], 1),
                callback: cmd => {
                    const value = cmd.path[3];
                    if (value === 'activate') {
                        this.sendCommandResponse(cmd.resultId, 'SpeakerTrackActivateResult', 'OK');
                    }
                    else if (value === 'deactivate') {
                        this.sendCommandResponse(cmd.resultId, 'SpeakerTrackDeactivateResult', 'OK');
                    }
                    else {
                        this.sendXPathError(cmd.path, cmd.resultId, 'Unknown command');
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'dial']),
                callback: cmd => {
                    var _a;
                    if (!this.argsIncludesRequired(cmd.args, ['number']) ||
                        !this.argsAreValid(cmd.args, ['calltype', 'number'])) {
                        this.sendCommandResponse(cmd.resultId, 'DialResult', 'ParameterError');
                        return;
                    }
                    const callType = (_a = cmd.args.calltype.toLowerCase()) !== null && _a !== void 0 ? _a : 'video';
                    if (callType !== undefined && callType !== 'audio' && callType !== 'video') {
                        this.sendCommandResponse(cmd.resultId, 'DialResult', 'ParameterError');
                        return;
                    }
                    this.sendCommandResponse(cmd.resultId, 'CallDialResult', 'OK');
                    const newCall = {
                        CallType: { Value: callType === 'audio' ? 'Audio' : 'Video' },
                        Direction: { Value: 'Outgoing' },
                        DisplayName: { Value: "Craig's Office" },
                        CallbackNumber: { Value: cmd.args.number },
                        RemoteNumber: { Value: cmd.args.number },
                        Status: { Value: 'Connected' },
                        id: this.getNewCallId(),
                    };
                    const newState = Sutl.deepCopy(this.state);
                    newState.Status.Call.push(newCall);
                    this.updateState(newState);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'gpio', 'manualstate', 'set']),
                callback: cmd => {
                    const pinKeys = ['pin1', 'pin2', 'pin3', 'pin4'];
                    let status = 'OK';
                    if (!this.argsAreValid(cmd.args, pinKeys)) {
                        status = 'ParameterError';
                    }
                    else {
                        for (const key of pinKeys) {
                            const value = cmd.args[key].toLowerCase();
                            if (value !== undefined && value !== 'high' && value !== 'low') {
                                status = 'ParameterError';
                            }
                        }
                    }
                    this.sendCommandResponse(cmd.resultId, 'ManualStateSetResult', status);
                    if (status === 'OK') {
                        pinKeys.forEach((key, i) => {
                            const value = cmd.args[key].toLowerCase();
                            const newState = Sutl.deepCopy(this.state);
                            newState.Status.GPIO.Pin[i + 1].State.Value =
                                value === 'high' ? 'High' : 'Low';
                        });
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'peripherals', 'connect']),
                callback: cmd => {
                    let status = 'OK';
                    if (!this.argsIncludesRequired(cmd.args, ['id', 'type']) ||
                        !this.argsAreValid(cmd.args, [
                            'hardwareinfo',
                            'id',
                            'name',
                            'networkaddress',
                            'serialnumber',
                            'softwareinfo',
                            'type',
                        ])) {
                        status = 'ParameterError';
                    }
                    this.sendCommandResponse(cmd.resultId, 'PeripheralsConnectResult', status);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'peripherals', 'heartbeat']),
                callback: cmd => {
                    let status = 'OK';
                    if (!this.argsIncludesRequired(cmd.args, ['id']) ||
                        !this.argsAreValid(cmd.args, ['id'])) {
                        status = 'ParameterError';
                    }
                    this.sendCommandResponse(cmd.resultId, 'PeripheralsHeartbeatResult', status);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'presentation', 'start']),
                callback: cmd => {
                    var _a;
                    if (!this.argsIncludesRequired(cmd.args, ['presentationsource']) ||
                        !this.argsAreValid(cmd.args, ['presentationsource'])) {
                        this.sendCommandResponse(cmd.resultId, 'PresentationStartResult', 'ParameterError');
                        return;
                    }
                    const value = (_a = cmd.args.presentationsource) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                    this.sendCommandResponse(cmd.resultId, 'PresentationStartResult', 'OK');
                    const newState = Sutl.deepCopy(this.state);
                    newState.Status.Conference.Presentation.LocalInstance = [
                        { Source: { Value: value }, id: '1' },
                    ];
                    this.updateState(newState);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'presentation', 'stop']),
                callback: cmd => {
                    var _a;
                    this.sendCommandResponse(cmd.resultId, 'PresentationStopResult', 'OK');
                    if (((_a = this.state.Status.Conference.Presentation.LocalInstance) !== null && _a !== void 0 ? _a : []).length > 0) {
                        const newState = Sutl.deepCopy(this.state);
                        newState.Status.Conference.Presentation.LocalInstance = [
                            { id: '1', ghost: 'True' },
                        ];
                        this.updateState(newState);
                        delete newState.Status.Conference.Presentation.LocalInstance; // don't update afterwards
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'standby'], 1),
                callback: cmd => {
                    var _a;
                    const value = (_a = cmd.path[2]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                    if (value === 'activate') {
                        this.sendCommandResponse(cmd.resultId, 'StandbyActivateResult', 'OK');
                        const newState = Sutl.deepCopy(this.state);
                        newState.Status.Standby.State.Value = 'Standby';
                        this.updateState(newState);
                    }
                    else if (value === 'deactivate') {
                        this.sendCommandResponse(cmd.resultId, 'StandbyDeactivateResult', 'OK');
                        const newState = Sutl.deepCopy(this.state);
                        newState.Status.Standby.State.Value = 'Off';
                        this.updateState(newState);
                    }
                    else if (value === 'resettimer') {
                        this.sendCommandResponse(cmd.resultId, 'StandbyResetTimerResult', 'OK');
                    }
                    else {
                        this.sendXPathError(cmd.path, cmd.resultId, 'No match on address expression');
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xcommand', 'video', 'selfview', 'set']),
                callback: cmd => {
                    if (!this.argsAreValid(cmd.args, [
                        'fullscreenmode',
                        'mode',
                        'onmonitorrole',
                        'pipposition',
                    ])) {
                        this.sendCommandResponse(cmd.resultId, 'SelfviewSetResult', 'ParameterError');
                        return;
                    }
                    const newState = Sutl.deepCopy(this.state);
                    if (cmd.args.fullscreenmode !== undefined) {
                        const value = cmd.args.fullscreenmode.toLowerCase();
                        if (value !== 'on' && value !== 'off') {
                            this.sendCommandResponse(cmd.resultId, 'SelfviewSetResult', 'ParameterError', { FullscreenMode: { Value: 'Invalid value' } });
                            return;
                        }
                        newState.Status.Video.Selfview.FullscreenMode.Value =
                            value === 'on' ? 'On' : 'Off';
                    }
                    if (cmd.args.mode !== undefined) {
                        const value = cmd.args.mode.toLowerCase();
                        if (value !== 'on' && value !== 'off') {
                            this.sendCommandResponse(cmd.resultId, 'SelfviewSetResult', 'ParameterError', { Mode: { Value: 'Invalid value' } });
                            return;
                        }
                        newState.Status.Video.Selfview.Mode.Value =
                            cmd.args.mode.toLowerCase() === 'on' ? 'On' : 'Off';
                    }
                    if (cmd.args.onmonitorrole !== undefined) {
                        const value = cmd.args.onmonitorrole.toLowerCase();
                        const monitorRole = monitorRoles.find(role => value === role.toLowerCase());
                        if (monitorRole === undefined) {
                            this.sendCommandResponse(cmd.resultId, 'SelfviewSetResult', 'ParameterError', { OnMonitorRole: { Value: 'Invalid value' } });
                            return;
                        }
                        newState.Status.Video.Selfview.OnMonitorRole.Value = monitorRole;
                    }
                    if (cmd.args.pipposition !== undefined) {
                        const value = cmd.args.pipposition.toLowerCase();
                        const pipPosition = pipPositions.find(pip => value === pip.toLowerCase());
                        if (pipPosition === undefined) {
                            this.sendCommandResponse(cmd.resultId, 'SelfviewSetResult', 'ParameterError', { PIPPosition: { Value: 'Invalid value' } });
                            return;
                        }
                        newState.Status.Video.Selfview.PIPPosition.Value = pipPosition;
                    }
                    this.sendCommandResponse(cmd.resultId, 'SelfviewSetResult', 'OK');
                    this.updateState(newState);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xfeedback', 'help']),
                callback: cmd => {
                    this.sendXFeedbackHelp();
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xfeedback', 'deregister'], 1, true),
                callback: cmd => {
                    var _a;
                    const key = cmd.path[2];
                    if (key === undefined) {
                        this.sendXFeedbackHelp();
                    }
                    else {
                        (_a = this.registrations[key]) === null || _a === void 0 ? void 0 : _a.subscription.unsubscribe();
                        delete this.registrations[key];
                        this.sendJson({}, cmd.resultId);
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xfeedback', 'deregisterall']),
                callback: cmd => {
                    var _a;
                    for (const key of Object.keys(this.registrations)) {
                        (_a = this.registrations[key]) === null || _a === void 0 ? void 0 : _a.subscription.unsubscribe();
                        delete this.registrations[key];
                    }
                    this.sendJson({}, cmd.resultId);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xfeedback', 'list']),
                callback: cmd => {
                    for (const key of Object.keys(this.registrations)) {
                        this.socket.send(key);
                    }
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xfeedback', 'register'], 1),
                callback: cmd => {
                    var _a;
                    let pathName = (_a = cmd.path[2]) !== null && _a !== void 0 ? _a : '';
                    if (pathName[0] !== '/')
                        pathName = `/${pathName}`;
                    const path = pathName
                        .substring(1)
                        .split('/')
                        .map(p => { var _a; return (_a = this.keymap[p]) !== null && _a !== void 0 ? _a : p; });
                    if (this.registrations[pathName] === undefined) {
                        let prevState = Sutl.getProp(this.state, path);
                        const subscription = this.stateSubject.subscribe(state => {
                            const currState = Sutl.getProp(state, path);
                            if (!Sutl.objEquals(currState, prevState)) {
                                const feedback = Sutl.setProp({}, path, currState);
                                this.sendJson(feedback, undefined);
                                prevState = currState;
                            }
                        });
                        this.registrations[pathName] = { path, subscription };
                    }
                    this.sendJson({}, cmd.resultId);
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xpreferences', 'outputmode', 'json']),
                callback: cmd => {
                    // nop
                },
            },
            {
                match: (cmd) => this.matchPath(cmd, ['xstatus'], -1, true),
                callback: cmd => {
                    const path = ['status', ...cmd.path.slice(1)].map(p => { var _a; return (_a = this.keymap[p]) !== null && _a !== void 0 ? _a : p; });
                    const resp = Sutl.setProp({}, path, Sutl.getProp(this.state, path));
                    this.sendJson(resp, cmd.resultId);
                },
            },
            {
                name: 'invalid',
                match: (cmd) => cmd,
                callback: cmd => {
                    if (['xcommand', 'xfeedback', 'xstatus'].includes(cmd.path[0])) {
                        this.sendXPathError(cmd.path, cmd.resultId, 'Unknown command');
                    }
                    else {
                        this.socket.send(`Command not recognized.`);
                    }
                },
            },
        ];
        this.computeKeymap();
    }
    argsAreValid(args, validArgs) {
        for (const arg of Object.keys(args)) {
            if (!validArgs.includes(arg))
                return false;
        }
        return true;
    }
    argsIncludesRequired(args, requiredArgs) {
        const givenArgs = Object.keys(args);
        for (const requiredArg of requiredArgs) {
            if (!givenArgs.includes(requiredArg))
                return false;
        }
        return true;
    }
    computeKeymap(state = this.state) {
        this.keymap.localinstance = 'LocalInstance';
        if (Array.isArray(state)) {
            for (const item of state) {
                this.computeKeymap(item);
            }
        }
        else if (typeof state === 'object' && state !== null) {
            for (const [key, value] of Object.entries(state)) {
                this.keymap[key.toLowerCase()] = key;
                this.computeKeymap(value);
            }
        }
    }
    findCall(callId, state) {
        return (state !== null && state !== void 0 ? state : this.state).Status.Call.find(call => call.id === callId);
    }
    getNewCallId() {
        return (this.callId++).toString();
    }
    parser(command) {
        if (this.echo)
            this.socket.send(command);
        let resultId;
        const match = this.resultIdRegExp.exec(command);
        if (match) {
            command = match[1];
            resultId = match[2];
        }
        let isQuoted = false;
        let isEscaped = false;
        let n = 0;
        let token = undefined;
        const tokens = [];
        while (n < command.length) {
            const ch = command[n];
            if (!isEscaped && ch === '\\') {
                isEscaped = true;
            }
            else if (token === undefined) {
                if (ch === ' ' || ch === '\t') {
                    // nop
                }
                else if (ch === '"') {
                    token = '';
                    isQuoted = true;
                }
                else {
                    token = ch;
                }
                isEscaped = false;
            }
            else {
                if (isQuoted) {
                    if (!isEscaped && ch === '"') {
                        tokens.push(token);
                        token = undefined;
                        isQuoted = false;
                    }
                    else {
                        token += ch;
                    }
                }
                else {
                    if (ch === ' ' || ch === '\t') {
                        tokens.push(token);
                        token = undefined;
                    }
                    else {
                        token += ch;
                    }
                }
                isEscaped = false;
            }
            n++;
        }
        if (token !== undefined)
            tokens.push(token);
        const path = [];
        const args = {};
        let key;
        for (token of tokens) {
            if (key === undefined) {
                if (token.endsWith(':')) {
                    key = token.toLowerCase().substring(0, token.length - 1);
                }
                else {
                    path.push(token.toLowerCase());
                }
            }
            else {
                args[key] = token;
                key = undefined;
            }
        }
        return { args, path, resultId };
    }
    matchPath(cmd, path, extra = 0, isExtraOptional = false) {
        if ((isExtraOptional &&
            extra >= 0 &&
            cmd.path.length !== path.length &&
            cmd.path.length !== path.length + extra) ||
            (isExtraOptional && extra < 0 && cmd.path.length < path.length) ||
            (!isExtraOptional && cmd.path.length !== path.length + extra)) {
            return undefined;
        }
        for (let i = 0; i < path.length; i++) {
            if (cmd.path[i].toLowerCase() !== path[i].toLowerCase())
                return undefined;
        }
        return cmd;
    }
    onConfigure(config) {
        // TODO: unsubscribe all
    }
    onDisconnect() {
        // TODO: unsubscribe all
    }
    sendJson(data, resultId) {
        if (!Array.isArray(data) &&
            typeof data === 'object' &&
            data !== null &&
            resultId !== undefined) {
            data.ResultId = resultId;
        }
        this.socket.send(JSON.stringify(data, null, 2));
    }
    sendCommandResponse(resultId, name, status, data) {
        const resp = { CommandResponse: {} };
        if (data !== undefined) {
            Sutl.setProp(resp, ['CommandResponse', name], data);
        }
        Sutl.setProp(resp, ['CommandResponse', name, 'status'], status);
        this.sendJson(resp, resultId);
    }
    sendCommandErrorWithReason(resultId, name, reason, status = 'Error') {
        this.sendCommandResponse(resultId, name, status, { Reason: { Value: reason } });
    }
    sendXFeedbackHelp() {
        this.socket.send(`xFeedback help:`);
        this.socket.send(`  xFeedback register XPathExpression[1..200]   - Registers feedback on expression XPathExpression.`);
        this.socket.send(`  xFeedback deregister XPathExpression[1..200] - Deregisters feedback if registered on XPathExpression.`);
        this.socket.send(`  xFeedback deregisterall                      - Deregister all expressions`);
        this.socket.send(`  xFeedback list                               - Generate list of currently registered XPathExpressions.`);
        this.socket.send(`  xFeedback help                               - Display this hellp text.`);
    }
    sendXPathError(path, resultId, reason) {
        this.sendJson({
            CommandResponse: {
                Result: {
                    Reason: {
                        Value: reason,
                    },
                    XPath: {
                        Value: `/${path.join('/')}`,
                    },
                    status: 'Error',
                },
            },
        }, resultId);
    }
    wake() {
        if (this.state.Status.Standby.State.Value !== 'Off') {
            const newState = Sutl.deepCopy(this.state);
            newState.Status.Standby.State.Value = 'Off';
        }
    }
    updateState(state) {
        this.state = state;
        this.stateSubject.next(state);
    }
}
CiscoTelepresence.emulatorType = 'socketEmulator';
CiscoTelepresence.key = '-KmaYBQ2O8SUAQRQTumH';
